import React from 'react';
import { createPortal } from 'react-dom';
import { CalendarIcon, ChevronDownIcon } from '../icons';
import DateInput from './DateInput';

/**
 * DueDateDropdown Component
 * Dropdown for setting due date of selected missions
 */
const DueDateDropdown = ({
  isActive,
  onToggle,
  onDueDateChange,
  menuStyle,
  buttonRef,
}) => {
  return (
    <div className="bulk-actions-toolbar__dropdown-container">
      <button
        ref={buttonRef}
        className={`bulk-actions-toolbar__btn ${isActive ? 'bulk-actions-toolbar__btn--active' : ''}`}
        onClick={(e) => onToggle('dueDate', e.currentTarget)}
        title="Set due date"
      >
        <CalendarIcon />
        <span>Due</span>
        <ChevronDownIcon />
      </button>
      {isActive && createPortal(
        <div className="bulk-actions-toolbar__menu bulk-actions-toolbar__menu--date" style={menuStyle}>
          <DateInput
            onChange={onDueDateChange}
            presets={[
              { label: 'Clear due date', value: null },
              { label: 'Today', value: 0 },
              { label: 'Tomorrow', value: 1 },
              { label: 'Next week', value: 7 },
            ]}
          />
        </div>,
        document.body
      )}
    </div>
  );
};

export default DueDateDropdown;
